var convertFormDataToChangePasswordRequest = function convertFormDataToChangePasswordRequest(formData) {
  return {
    currentPassword: formData.currentPassword,
    newPassword: formData.password,
    newPasswordConfirmation: formData.passwordConfirmation
  };
};
export default convertFormDataToChangePasswordRequest;